import axios from 'axios'
import { URL } from '../../../../config'

export const postStandardBowlers = function (updates,token) 
{
  return axios.post(`${URL.postevent}/standardbowlers/update`,updates,
	{ 
    crossdomain: true,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'Authorization' : `Bearer ${token}` 
    }
  })  
}


// WEBPACK FOOTER //
// ./src/components/pages/Event/api/postStandardBowlers.js